import {
  CalendarIcon,
  DeviceMobileIcon,
  GlobeIcon,
  InfoIcon,
  KebabHorizontalIcon,
  LinkIcon,
  LocationIcon,
  MailIcon,
  NoteIcon,
  PencilIcon,
  PersonIcon,
  PlusIcon,
  ShareAndroidIcon,
  SyncIcon,
  TrashIcon,
  UploadIcon,
  WorkflowIcon,
  DownloadIcon,
  PasskeyFillIcon,
} from "@primer/octicons-react";
import {
  ActionList,
  ActionMenu,
  Box,
  IconButton,
  Label,
  useConfirm,
} from "@primer/react";
import moment from "moment";
import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { crmHocSinhApi } from "../../api/crmHocSinhApi";
import { ComboboxTruong } from "../../components/combobox-truong";
import {
  HocSinhRender,
  Infomation,
} from "../../components/hoc-sinh/HocSinhRender";
import SelectBoxTrangThaiHocSinhMultiple from "../../components/selectbox-trangthai-hocsinh-multiple";
import TextTranslated from "../../components/text";
import Button from "../../components/ui/button";
import DataTable from "../../components/ui/data-table";
import UserAvatar from "../../components/user-avatar";
import { useCommonContext } from "../../contexts/common";
import { NotifyHelper } from "../../helpers/toast";
import { useCommonSelectedHook } from "../../hooks/useCommonSelectedHook";
import { ePageBaseStatus } from "../../models/ePageBaseStatus";
import { IHocSinhSelectRequest } from "../../models/request/hoc-sinh/IHocSinhSelectRequest";
import { IHocSinhItemResponse } from "../../models/response/crm-hocsinh/IHocSinhItemResponse ";
import { actions } from "../../state/actions/actionsWrapper";
import { RootState } from "../../state/reducers";
import HocSinhProfile from "../hoc-sinh-profile";
import ImportHocSinhModal from "./import-hoc-sinh-modal/ImportHocSinhModal";
import * as XLSX from "xlsx";

const HocSinhPage = ({
  onValueChanged,
}: {
  onValueChanged?: (values: { dm_trangthaihocsinh_ids: string }) => void;
}) => {
  const { status, hocSinhs } = useSelector(
    (state: RootState) => state.crmHocSinh
  );
  const { nam_hoc, dm_coso_id } = useCommonSelectedHook();
  const { translate } = useCommonContext();
  const confirm = useConfirm();
  const dispatch = useDispatch();

  const { dm_truong_selected_id } = useSelector((x: RootState) => x.common);
  const [dm_trangthaihocsinh_ids, setDmTrangThaiIds] = useState<number[]>([]);
  const [isShowModal, setIsShowModal] = useState(false);
  const [selectedId, setSelectedId] = useState(0);
  const [hocSinhEditing, setHocSinhEditing] = useState({ id: 0 });
  const [allHocSinhs, setAllHocSinhs] = useState<any[]>([]);
  const [isShowModalImport, setIsShowModalImport] = useState(false);

  useEffect(() => {
    const loadAllHocSinh = async () => {
      const payload: IHocSinhSelectRequest = {
        nam_hoc: nam_hoc,
        searchText: "",
        dm_trangthaihocsinh_ids: [],
        dm_truong_id: dm_truong_selected_id || 0, 
        dm_coso_id: dm_coso_id || 1,
        dm_khoi_id: 0,
        dm_he_id: 0,
        dm_lop_id: 0,
      };
      const res = await crmHocSinhApi.select(payload);
      if (res.is_success) {
        setAllHocSinhs(res.data);
      }
    };

    loadAllHocSinh();

  }, [nam_hoc, dm_truong_selected_id, dm_coso_id]);

  const handleReload = useCallback(() => {
    const payload: IHocSinhSelectRequest = {
      nam_hoc: nam_hoc,
      searchText: "",
      dm_trangthaihocsinh_ids: dm_trangthaihocsinh_ids,
      dm_truong_id: dm_truong_selected_id,
      dm_coso_id: dm_coso_id,
      dm_khoi_id: 0,
      dm_he_id: 0,
      dm_lop_id: 0,
    };
    dispatch(actions.crmHocSinh.LOAD_START(payload));
  }, [
    nam_hoc,
    dm_trangthaihocsinh_ids,
    dm_truong_selected_id,
    dm_coso_id,
    dispatch,
  ]);

  useEffect(() => {
    if (
      status === ePageBaseStatus.is_not_initialization ||
      status === ePageBaseStatus.is_need_reload
    ) {
      handleReload();
    }
  }, [status, handleReload]);

  useEffect(() => {
    handleReload();
  }, [dm_truong_selected_id, handleReload]);

  const handeDelete = async (id: number) => {
    if (
      await confirm({
        content: `${translate("Base.Label.ConfirmDelete")}`,
        title: `${translate("Base.Label.Warning")}`,
        cancelButtonContent: `${translate("Base.Label.No")}`,
        confirmButtonContent: `${translate("Base.Label.Yes")}`,
        confirmButtonType: "danger",
      })
    ) {
      const res = await crmHocSinhApi.delete(id);
      if (res.is_success) {
        NotifyHelper.Success("Success");
        handleReload();
      } else {
        NotifyHelper.Error(res.message ?? "");
      }
    }
  };

  const handleEditClick = (data: any) => {
    setHocSinhEditing(data); // Cập nhật hocSinhEditing với dữ liệu hiện tại
    setIsShowModal(true); // Mở modal
  };
  const handleCloseDetailModal = useCallback(() => {
    setIsShowModalImport(false);
  }, []);

  const handleExportExcel = () => {
    const exportData = hocSinhs.map((item) => ({
      "Mã học sinh": item.ma_hs,
      "Họ tên": item.ho_ten,
      "Trạng thái": item.trang_thai,
      "Ngày sinh": moment(item.ngay_sinh).format("DD/MM/YYYY"),
      "Giới tính": item.gioi_tinh,
      "Quốc tịch": item.quoc_tich,
      "Dân tộc": item.dan_toc,
      "Tôn giáo": item.ton_giao,
      "Địa chỉ": item.dia_chi_tt,
      Trường: item.ten_truong,
      Khối: item.ten_khoi,
      Lớp: item.ten_lop,
      Hệ: item.ten_he,
      "Năm nhập học": item.nam_nhap_hoc,
      "Ngày đăng ký": moment(item.ngay_dang_ky).format("DD/MM/YYYY"),
      "Họ tên cha": item.ho_ten_lien_he_cha,
      "Điện thoại cha": item.dien_thoai_lien_he_cha,
      "Email cha": item.email_lien_he_cha,
      "Họ tên mẹ": item.ho_ten_lien_he_me,
      "Điện thoại mẹ": item.dien_thoai_lien_he_me,
      "Email mẹ": item.email_lien_he_me,
    }));
    const ws = XLSX.utils.json_to_sheet(exportData);
    if (!ws["!ref"]) {
      return;
    }
    const columnWidths = [
      { wch: 15 }, // Mã học sinh
      { wch: 25 }, // Họ tên
      { wch: 15 }, // Trạng thái
      { wch: 15 }, // Ngày sinh
      { wch: 10 }, // Giới tính
      { wch: 15 }, // Quốc tịch
      { wch: 15 }, // Dân tộc
      { wch: 15 }, // Tôn giáo
      { wch: 30 }, // Địa chỉ
      { wch: 25 }, // Trường
      { wch: 10 }, // Khối
      { wch: 10 }, // Lớp
      { wch: 20 }, // Hệ
      { wch: 15 }, // Năm nhập học
      { wch: 15 }, // Ngày đăng ký
      { wch: 25 }, // Họ tên cha
      { wch: 15 }, // Điện thoại cha
      { wch: 25 }, // Email cha
      { wch: 25 }, // Họ tên mẹ
      { wch: 15 }, // Điện thoại mẹ
      { wch: 25 }, // Email mẹ
    ];
    ws["!cols"] = columnWidths;
    const headerStyle = {
      font: {
        bold: true,
        color: { rgb: "FFFFFF" },
      },
      fill: {
        fgColor: { rgb: "4472C4" },
      },
      alignment: {
        horizontal: "center",
        vertical: "center",
      },
      border: {
        top: { style: "thin" },
        bottom: { style: "thin" },
        left: { style: "thin" },
        right: { style: "thin" },
      },
    };
    const range = XLSX.utils.decode_range(ws["!ref"]);
    const headerRange = {
      s: { r: 0, c: 0 },
      e: { r: 0, c: range.e.c },
    };
    for (let col = headerRange.s.c; col <= headerRange.e.c; col++) {
      const cellRef = XLSX.utils.encode_cell({ r: 0, c: col });
      if (!ws[cellRef]) continue;
      ws[cellRef].s = headerStyle;
    }
    ws["!rows"] = [{ hpt: 30 }]; 
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Danh sách học sinh");
    const title = `DANH SÁCH HỌC SINH ${moment().format("DD/MM/YYYY")}`;
    const wsTitle = XLSX.utils.aoa_to_sheet([[title]]);
    const titleStyle = {
      font: {
        bold: true,
        size: 16,
        color: { rgb: "000000" },
      },
      alignment: {
        horizontal: "center",
        vertical: "center",
      },
    };
    wsTitle["A1"].s = titleStyle;
    wsTitle["!merges"] = [{ s: { r: 0, c: 0 }, e: { r: 0, c: range.e.c } }];
    XLSX.writeFile(
      wb,
      `Danh_sach_hoc_sinh_${moment().format("DD-MM-YYYY")}.xlsx`,
      { bookType: "xlsx", type: "binary" }
    );
  };

  return (
    <Box
      sx={{
        p: 3,
        overflowX: "auto",
      }}
    >
      <DataTable
        height={`${window.innerHeight - 230}px`}
        data={hocSinhs}
        isLoading={status === ePageBaseStatus.is_loading}
        title={translate("Học sinh")}
        subTitle={`${translate("Base.Label.TotalCount")}: ${hocSinhs.length}`}
        searchEnable
        paging={{ enable: true }}
        actionComponent={
          <Box
            sx={{
              display: "flex",
            }}
          >
            <SelectBoxTrangThaiHocSinhMultiple
              selectedValue={dm_trangthaihocsinh_ids}
              onSelectionChanged={(ids) => {
                setDmTrangThaiIds(ids);
                onValueChanged &&
                  onValueChanged({
                    dm_trangthaihocsinh_ids: ids.join(","),
                  });
              }}
              maxWidth={300}
              isShowClearBtn={true}
              hocSinhs={allHocSinhs}
            />

            <ComboboxTruong
              value={dm_truong_selected_id}
              onValueChanged={(value) => {
                dispatch(
                  actions.common.changedValueHeaderComboboxTruong(value)
                );
              }}
              isShowClearButton={true}
            />
            <Button
              sx={{ ml: 1 }}
              text="Base.Label.AddNew"
              leadingVisual={PlusIcon}
              size="medium"
              variant="primary"
              onClick={() => {
                handleEditClick([]);
              }}
            />
            
            <Button
              sx={{ ml: 1 }}
              text="Base.Label.Import"
              leadingVisual={UploadIcon}
              size="medium"
              variant="default"
              onClick={() => {
                setIsShowModalImport(true);
              }}
            />
            <Button
              sx={{ ml: 1 }}
              text="Export"
              leadingVisual={DownloadIcon}
              size="medium"
              variant="default"
              onClick={handleExportExcel}
            />
            <Button
              text="Base.Label.Refresh"
              leadingVisual={SyncIcon}
              size="medium"
              sx={{ ml: 1 }}
              onClick={() => {
                handleReload();
              }}
            />
          </Box>
        }
        columns={[
          {
            id: "cmd",
            width: "50px",
            caption: '#',
            align: "center",
            fixed: true,
            cellRender: (data: IHocSinhItemResponse) => {
              return (
                <ActionMenu>
                  <ActionMenu.Anchor>
                    <IconButton
                      icon={KebabHorizontalIcon}
                      variant="invisible"
                      aria-label="Open column options"
                    />
                  </ActionMenu.Anchor>

                  <ActionMenu.Overlay>
                    <ActionList>
                      <ActionList.Item onSelect={() => handleEditClick(data)}>
                        <ActionList.LeadingVisual>
                          <PencilIcon />
                        </ActionList.LeadingVisual>
                        <TextTranslated value="Base.Label.Edit" />
                      </ActionList.Item>
                      <ActionList.Divider />
                      <ActionList.Item
                        variant="danger"
                        onSelect={() => {
                          handeDelete(data.id);
                        }}
                      >
                        <ActionList.LeadingVisual>
                          <TrashIcon />
                        </ActionList.LeadingVisual>
                        <TextTranslated value="Base.Label.Delete" />
                      </ActionList.Item>
                    </ActionList>
                  </ActionMenu.Overlay>
                </ActionMenu>
              );
            },
          },
          {
            dataField: "trang_thai",
            width: "100px",
            caption: translate("Trạng thái"),
            fixed: true,
            cellRender: (data: IHocSinhItemResponse) => {
              return (
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    height: "100%",
                  }}
                >
                  <Label
                    style={{ marginLeft: "5px" }}
                    variant={
                      data.trang_thai === "New Enrollment"
                        ? "accent"
                        : data.trang_thai === "Re-Enrollment"
                        ? "success"
                        : data.trang_thai === "Tiềm năng"
                        ? "sponsors"
                        : data.trang_thai === "Thôi học"
                        ? "danger"
                        : "default"
                    }
                  >
                    {data.trang_thai}
                  </Label>
                </Box>
              );
            },
          },
          {
            dataField: "avatar",
            width: "100px",
            caption: translate("Avatar"),
            fixed: true,
            cellRender: (data: IHocSinhItemResponse) => {
              return (
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    height: "100%",
                  }}
                >
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <div style={{ color: "#10375C" }}>
                      <UserAvatar fullName={data.ho_ten} size="large" />
                    </div>
                  </div>
                </Box>
              );
            },
          },
          {
            dataField: "ma_hs",
            isVisible: false,
          },
          {
            dataField: "ho_ten",
            isVisible: false,
          },
          {
            dataField: "ho_ten",
            caption: translate("Học sinh"),
            cellRender: (data: IHocSinhItemResponse) => {
              const infos: Infomation[] = [
                { title: '', data: data.ho_ten, icon: <PersonIcon size={14} />,fontWeight: "500"  },
                { title: '', data: data.ho_ten_en, icon: <WorkflowIcon size={14} /> },
                { title: '', data: data.ma_hs, icon: <NoteIcon size={14} /> },
              ];
              return (
                <HocSinhRender infors={infos} />
              )
            },
          },
          {
            dataField: "thong_tin_2",
            caption: translate("Thông tin"),
            cellRender: (data: IHocSinhItemResponse) => {
              const infos: Infomation[] = [
                {
                  title: "Ngày sinh",
                  data: moment(data.ngay_sinh).format("DD/MM/YYYY"),
                  icon: <CalendarIcon size={14} />,
                },
                {
                  title: "Giới tính",
                  data: data.gioi_tinh,
                  icon: <InfoIcon size={14} />,
                },
              ];
              return <HocSinhRender infors={infos} />;
            },
          },
          {
            dataField: "thong_tin_1",
            caption: translate("Quốc tịch"),
            cellRender: (data: IHocSinhItemResponse) => {
              const infos: Infomation[] = [
                { title: 'Quốc tịch', data: data.quoc_tich, icon: <GlobeIcon size={14} /> },
                { title: 'Dân tộc', data: data.dan_toc, icon: <InfoIcon size={14} /> },
                { title: 'Tôn giáo', data: data.ton_giao, icon: <InfoIcon size={14} /> },
              ];
              return (
                <HocSinhRender infors={infos} />
              )
            },
          },
          {
            dataField: "dia_chi",
            caption: translate("Địa chỉ hiện tại"),
            cellRender: (data: IHocSinhItemResponse) => {
              const infos: Infomation[] = [
                { title: '', data: data.dia_chi_hientai, icon: <LocationIcon size={14} /> },
              ];
              return (
                <HocSinhRender infors={infos} />
              )
            },
          },
          {
            dataField: "thong_lop",
            caption: translate("Trường lớp"),
            cellRender: (data: IHocSinhItemResponse) => {
              return (
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "baseline",
                  }}
                >
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <div style={{ color: "#FF9D3D" }}>
                      <ShareAndroidIcon size={14} />
                    </div>
                    <span style={{ fontWeight: "500", marginLeft: "5px" }}>
                      {data.ten_truong} - {data.ten_khoi} - {data.ten_lop}
                    </span>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      paddingTop: "3px",
                    }}
                  >
                    <div style={{ color: "green" }}>
                      <LinkIcon size={14} />
                    </div>
                    <Label
                      style={{ marginLeft: "5px" }}
                      variant={
                        data.ten_he === "Bilingual Track"
                          ? "accent"
                          : data.ten_he === "International Track"
                          ? "success"
                          : "default"
                      }
                    >
                      {data.ten_he}
                    </Label>
                  </div>
                </Box>
              );
            },
          },
          {
            dataField: "nam_nhap_hoc",
            caption: translate("Năm nhập học"),
            cellRender: (data: IHocSinhItemResponse) => {
              return (
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    whiteSpace: "nowrap",
                  }}
                >
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <div style={{ color: "#133E87" }}>
                      <CalendarIcon size={14} />
                    </div>
                    <span style={{ marginLeft: "5px" }}>
                      {data.nam_nhap_hoc}
                    </span>
                  </div>
                </Box>
              );
            },
          },
          {
            dataField: "ngay_dang_ky",
            caption: translate("Ngày đăng ký"),
            cellRender: (data: IHocSinhItemResponse) => {
              return (
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    whiteSpace: "nowrap",
                  }}
                >
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <div style={{ color: "#133E87" }}>
                      <CalendarIcon size={14} />
                    </div>
                    <span style={{ marginLeft: "5px" }}>
                      {moment(data.ngay_dang_ky).format("DD/MM/YYYY")}
                    </span>
                  </div>
                </Box>
              );
            },
          },
          {
            dataField: "thong_tin_khac",
            caption: translate("Thông tin khác"),
            cellRender: (data: IHocSinhItemResponse) => {
              return (
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "baseline",
                    whiteSpace: "nowrap",
                  }}
                >
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <div style={{ color: "#133E87" }}>
                      <InfoIcon size={14} />
                    </div>
                    <span style={{ marginLeft: "5px" }}>
                      Mã định danh: <span> {data.ma_dinh_danh || "..."}</span>
                    </span>
                  </div>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <div style={{ color: "#133E87" }}>
                      <InfoIcon size={14} />
                    </div>
                    <span style={{ marginLeft: "5px" }}>
                      Nguồn biết tới:{" "}
                      <span style={{ fontWeight: "500" }}>
                        {" "}
                        {data.nguon_biet_toi || "..."}
                      </span>
                    </span>
                  </div>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <div style={{ color: "#133E87" }}>
                      <InfoIcon size={14} />
                    </div>
                    <span style={{ marginLeft: "5px" }}>
                      Trường cũ:{" "}
                      <span style={{ fontWeight: "500" }}>
                        {" "}
                        {data.truong_hoc_cu || "..."}
                      </span>
                    </span>
                  </div>
                </Box>
              );
            },
          },
          {
            dataField: "thong_tin_cha",
            caption: translate("Thông tin cha"),
            cellRender: (data: IHocSinhItemResponse) => {
              return (
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "baseline",
                    whiteSpace: "nowrap",
                  }}
                >
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <div style={{ color: "#74512D" }}>
                      <PersonIcon size={14} />
                    </div>
                    <span
                      style={{
                        fontWeight: data.ho_ten_lien_he_cha ? "500" : "",
                        marginLeft: "5px",
                        color: data.ho_ten_lien_he_cha ? "inherit" : "#7D0A0A",
                      }}
                    >
                      {data.ho_ten_lien_he_cha || "..."}
                    </span>
                  </div>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <div style={{ color: "#133E87" }}>
                      <DeviceMobileIcon size={14} />
                    </div>{" "}
                    <span style={{ marginLeft: "5px" }}>
                      {data.dien_thoai_lien_he_cha || "..."}
                    </span>
                  </div>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <div style={{ color: "#133E87" }}>
                      <MailIcon size={14} />
                    </div>{" "}
                    <span style={{ marginLeft: "5px" }}>
                      {data.email_lien_he_cha || "..."}
                    </span>
                  </div>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <div style={{ color: "#74512D" }}>
                      <PasskeyFillIcon  size={14} />
                    </div>
                    <span
                      style={{
                        fontWeight: data.nguoiphutrach_cha ? "500" : "",
                        marginLeft: "5px",
                        color: data.nguoiphutrach_cha ? "inherit" : "#7D0A0A",
                      }}
                    >
                      {data.nguoiphutrach_cha || "..."}
                    </span>
                  </div>
                </Box>
              );
            },
          },
          {
            dataField: "thong_tin_me",
            caption: translate("Thông tin mẹ"),
            cellRender: (data: IHocSinhItemResponse) => {
              return (
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "baseline",
                    whiteSpace: "nowrap",
                  }}
                >
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <div style={{ color: "#B784B7" }}>
                      <PersonIcon size={14} />
                    </div>
                    <span
                      style={{
                        fontWeight: data.ho_ten_lien_he_me ? "500" : "",
                        marginLeft: "5px",
                        color: data.ho_ten_lien_he_me ? "inherit" : "#7D0A0A",
                      }}
                    >
                      {data.ho_ten_lien_he_me || "..."}
                    </span>
                  </div>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <div style={{ color: "#133E87" }}>
                      <DeviceMobileIcon size={14} />
                    </div>{" "}
                    <span style={{ marginLeft: "5px" }}>
                      {data.dien_thoai_lien_he_me || "..."}
                    </span>
                  </div>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <div style={{ color: "#133E87" }}>
                      <MailIcon size={14} />
                    </div>{" "}
                    <span style={{ marginLeft: "5px" }}>
                      {data.email_lien_he_me || "..."}
                    </span>
                  </div>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <div style={{ color: "#74512D" }}>
                      <PasskeyFillIcon  size={14} />
                    </div>
                    <span
                      style={{
                        fontWeight: data.nguoiphutrach_me ? "500" : "",
                        marginLeft: "5px",
                        color: data.nguoiphutrach_me ? "inherit" : "#7D0A0A",
                      }}
                    >
                      {data.nguoiphutrach_me || "..."}
                    </span>
                  </div>
                </Box>
              );
            },
          },
          {
            dataField: "thong_tin_lien_he",
            caption: translate("Thông tin liên hệ "),
            cellRender: (data: IHocSinhItemResponse) => {
              return (
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "baseline",
                    whiteSpace: "nowrap",
                  }}
                >
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <div style={{ color: "#133E87" }}>
                      <PersonIcon size={14} />
                    </div>
                    <span
                      style={{
                        fontWeight: data.ho_ten_lien_he ? "500" : "",
                        marginLeft: "5px",
                        marginRight: "5px",

                        color: data.ho_ten_lien_he ? "inherit" : "#7D0A0A",
                      }}
                    >
                      {data.ho_ten_lien_he || "..."}
                    </span>
                    {data.quan_he_nguoi_lien_he
                      ? `(${data.quan_he_nguoi_lien_he})`
                      : ""}
                  </div>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <div style={{ color: "#133E87" }}>
                      <DeviceMobileIcon size={14} />
                    </div>{" "}
                    <span style={{ marginLeft: "5px" }}>
                      {data.dien_thoai_lien_he || "..."}
                    </span>
                  </div>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <div style={{ color: "#133E87" }}>
                      <MailIcon size={14} />
                    </div>{" "}
                    <span style={{ marginLeft: "5px" }}>
                      {data.email_lien_he || "..."}
                    </span>
                  </div>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <div style={{ color: "#74512D" }}>
                      <PasskeyFillIcon  size={14} />
                    </div>
                    <span
                      style={{
                        fontWeight: data.nguoiphutrach_giamho ? "500" : "",
                        marginLeft: "5px",
                        color: data.nguoiphutrach_giamho ? "inherit" : "#7D0A0A",
                      }}
                    >
                      {data.nguoiphutrach_giamho || "..."}
                    </span>
                  </div>
                </Box>
              );
            },
          },
        ]}
      />
      {isShowModal && (
        <HocSinhProfile
          id={hocSinhEditing.id}
          onClose={() => {
            setIsShowModal(false);
          }}
          onSuccess={() => {
            handleReload();
            // setIsShowModal(false);
          }}
        />
      )}
       {isShowModalImport && (
        <ImportHocSinhModal
          onClose={handleCloseDetailModal}
          animationOf={`#btnImport`}
          dm_truong_id={dm_truong_selected_id} 
          nam_hoc={nam_hoc}
        />
      )}

      {/* {isShowModalImport && (
        <ImportHocSinhModal
          onClose={handleCloseDetailModal}
          animationOf={`#btnImport`}
        />
      )} */}
    </Box>
  );
};

export default HocSinhPage;

